import styled from 'styled-components';

import SearchField from './SearchField';

export default styled(SearchField)`
  input {
    border-radius: 0.4rem;
    border-color: var(--primary500);
  }
`;
